import {FC} from 'react';

import {SvgIcon} from '@shared_web/components/core/svg_icon';

import {icon_warning_green} from '@mavismart_frontend/icons/icon_warning_green';
import {icon_warning_grey} from '@mavismart_frontend/icons/icon_warning_grey';
import {icon_warning_orange} from '@mavismart_frontend/icons/icon_warning_orange';
import {icon_warning_red} from '@mavismart_frontend/icons/icon_warning_red';

type DoorAlertLevel = 'green' | 'yellow' | 'red' | 'grey';

export const AlertSymbol: FC<{level: DoorAlertLevel}> = props => {
  return props.level === 'green' ? (
    <SvgIcon icon={icon_warning_green} color="transparent" size={25} />
  ) : props.level === 'yellow' ? (
    <SvgIcon icon={icon_warning_orange} color="transparent" size={25} />
  ) : props.level === 'red' ? (
    <SvgIcon icon={icon_warning_red} color="transparent" size={25} />
  ) : props.level === 'grey' ? (
    <SvgIcon icon={icon_warning_grey} color="transparent" size={25} />
  ) : (
    <></>
  );
};

AlertSymbol.displayName = 'AlertSymbol';
